import React from 'react';
import { Typography, Box } from '@mui/material';
import EditPersonalIdentty from '../../components/Identify/EditPersonalIdentty';
import EditLegalIdentty from '../../components/Identify/EditLegalIdentity';
import WithOutStoper from '../../components/Stopper/WithOutStoper';
import { useNavigate, useLocation } from 'react-router-dom';
import usePublisher from '../../hooks/usePublisher';
import { FormSkeleton } from '../../components/Feedback/Loaders';
import Breadcrumb from '../../components/Navigation/Breadcrumb';
import { SPACING } from '../../theme/theme';

const EditIdentify: React.FC = () => {
  const location = useLocation();
  const identify = location.state?.identify;
  const publisherId = location.state?.publisherId;
  const navigate = useNavigate();
  const {
    data: publisher,
    isLoading,
    isError,
    error,
  } = usePublisher(publisherId);

  console.log(publisher); // Inspect the publisher object

  if (isLoading) return <FormSkeleton fields={6} />;
  if (isError) return <Typography>Error: {error.message}</Typography>;

  // Transform the `publisher` object into the expected structure
  const initialValues = publisher
    ? {
        publisher: {
          name: publisher.name || '',
          display_name: publisher.display_name || '',
          national_id: publisher.national_id || '', // Use optional chaining
          address: publisher.address || '', // Use optional chaining
          postal_code: publisher.postal_code || '', // Use optional chaining
          phone: publisher.phone || '', // Use optional chaining
          id: publisher.id || 0,
        },
      }
    : undefined;

  if (!initialValues) {
    return (
      <Typography>Error: Publisher data is missing or incomplete.</Typography>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      // Other pages get this gutter from their PageContainer; without it the
      // breadcrumb sat flush against the header.
      sx={{ padding: `${SPACING.md}px`, width: '100%', boxSizing: 'border-box' }}
    >
      <Box sx={{ width: '100%', maxWidth: '1100px' }}>
        <Breadcrumb
          items={[
            { label: 'داشبورد', to: '/dashboard' },
            { label: 'هویت‌ها', to: '/identities' },
            ...(publisherId
              ? [
                  {
                    label: publisher?.display_name || 'تنظیمات هویت',
                    to: `/dashboard/identify/${publisherId}`,
                  },
                ]
              : []),
            { label: 'ویرایش هویت' },
          ]}
        />
      </Box>

      <Typography variant="body1" style={{marginTop: '10px'}}>
        {identify === 'PERSONAL' ? (
          <EditPersonalIdentty
            publisherId={publisherId}
            onNext={() => navigate('/dashboard')}
          />
        ) : identify === 'LEGAL' ? (
          <EditLegalIdentty
            publisherId={publisherId}
            onNext={() => navigate('/dashboard')}
          />
        ) : (
          <FormSkeleton fields={6} />
        )}
      </Typography>
    </Box>
  );
};

export default EditIdentify;
